import { gql } from '@apollo/client'

export default gql(`
mutation createRating($scheme: String!, $rating: [String!], $subRatings: [String!], $project: String) {
    createRating(
        input: {
            scheme: $scheme,
            rating: $rating,
            subRatings: $subRatings
        },
        project: $project
    ) {
        id
        scheme
        rating
        subRatings
        assetCount
        source
    }
}`
)
